import { Model } from "vue-mc";

export class Motivobaja extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , oob: false
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , oob: (oob) => oob
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/motivobaja.js